import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

const ACCESS_CODES = {
  'CBUY-USER-2024': { role: 'user', name: 'Handelsvertreter' },
  'CBUY-ADMIN-2024': { role: 'admin', name: 'Administrator' }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('cbuy-user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const login = (accessCode) => {
    const userData = ACCESS_CODES[accessCode];
    if (userData) {
      const user = { ...userData, accessCode };
      setUser(user);
      localStorage.setItem('cbuy-user', JSON.stringify(user));
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('cbuy-user');
  };

  const updateAccessCodes = (newCodes) => {
    // In einer echten App würde das über eine API gehen
    Object.assign(ACCESS_CODES, newCodes);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateAccessCodes }}>
      {children}
    </AuthContext.Provider>
  );
};